// extracted by mini-css-extract-plugin
export default {"collapsed-tab-list":"collapsed-tab-list--YnrB-ina1D","collapsedTabList":"collapsed-tab-list--YnrB-ina1D","root":"root--v1XyosJxtJ","inline":"inline--5hFyCj368E"};